import DocumentLink from '../../../../../components/minside/DocumentLink';
import InfoBox from '../../../../../components/minside/InfoBox';

// Samler sikkerhetskritiske dokumenter som deltakerne må sette seg inn i
// før arrangementet: øvingsdirektiv og sambandsplan for storøvelsen, og
// 5-punkts ordrer for de enkelte workshopene.
function DocumentsTab() {
    return (
        <div className="profile-tab">
            <section className="profile-section">
                <h4 className="profile-section__heading">Storøvelse — Øvelse Flåklypa</h4>
                <p>
                    Øvingsdirektivet beskriver risiko og organisering for storøvelsen på lørdag 6.
                    juni. Skal du delta på øvelsen, må du sette deg godt inn i direktivet og
                    sambandsplanen på forhånd.
                </p>
                <div className="documents-list">
                    <DocumentLink
                        title="Øvingsdirektiv – Øvelse Flåklypa"
                        description="Storøvelse lørdag 6. juni"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/ovingsdirektiv-floklypa-26-1.pdf"
                    />
                    <DocumentLink
                        title="Sambandsplan – Øvelse Flåklypa"
                        description="Sambandsplan for storøvelsen"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/sambandsplan-ovelse-flaklypa.pdf"
                    />
                </div>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">5-punkts ordre per workshop</h4>
                <p>
                    5-punkts ordrene redegjør for hva som skjer på den enkelte workshopen og hvilken
                    risiko du eksponeres for. Sett deg inn i ordrene for de workshopene du er
                    påmeldt.
                </p>
                <div className="documents-list">
                    <DocumentLink
                        title="5-punkts ordre – Redning i krevende terreng"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-redning-i-krevende-terreng.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Tilkomst og evakuering"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-tilkomst-og-evakuering.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Vannredning - elv"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-elveredning.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Masseskadetriage"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-masseskadetriage.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Innsatsledelse"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-innsatsledelse.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Innsatsledelse fredag"
                        description="Forberedelser til Øvelse Flåklypa"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-innsatsledelse-fredag.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Førsteinnsats snøskred"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-snoskred.pdf"
                    />
                    <DocumentLink
                        title="5-punkts ordre – Hypotermi"
                        meta="PDF · åpnes i ny fane"
                        href="https://sar61.no/wp-content/uploads/2026/05/5-punkt-ordre-hypotermi.pdf"
                    />
                </div>
                <InfoBox variant="info-muted">
                    <p>
                        Kontaktinfo til ansvarlig for den enkelte workshopen finner du i 5-punkts
                        ordren.
                    </p>
                </InfoBox>
            </section>
        </div>
    );
}

export default DocumentsTab;
